/**
 * engine/paths — lecture/écriture par chemin pointé (headless).
 * @author Dr Hamid MADANI <drmdh@msn.com>
 * MOTEUR — futur `@mostajs/app-admin` (N1, agnostique du rendu).
 */
export function getPath(obj, path) {
  if (!path) return undefined; // champs non liés aux données (ex. type 'action')
  return path.split('.').reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
}

/** Retourne une COPIE de `obj` avec `path` = `value` (immutable, crée les niveaux). */
export function setPath(obj, path, value) {
  const keys = path.split('.');
  const root = Array.isArray(obj) ? [...obj] : { ...(obj || {}) };
  let cur = root;
  for (let i = 0; i < keys.length - 1; i += 1) {
    const k = keys[i];
    cur[k] = Array.isArray(cur[k]) ? [...cur[k]] : { ...(cur[k] || {}) };
    cur = cur[k];
  }
  cur[keys[keys.length - 1]] = value;
  return root;
}
